<template>
  <div class="">
    <SideBarAdmin/>
    <div class="content">
     <router-view></router-view>
    </div>
  </div>
</template>
<script>
// eslint-disable-next-line
import axios from "@/axios";
import SideBarAdmin from '../template/SideBarAdmin.vue'
export default {
  data() {
    return {
      listRegister: []
    };
  },
  computed: { 
    // getBusinessType(){
    //   this.listRegister.type_business.map(item=>{
    //     return item.name
    //   });
    // }
  },
  methods: {
    async loadData(){
      // const respone = await axios.get("get-participant-register", {
      //   headers: {
      //     Authorization: "Bearer " + this.$store.getters.getAuthToken
      //   }
      // });
      // if (respone.status == 200) {
      //   this.listRegister = respone.data.data;
      //   console.log("this data:",respone.data);
      // }
    }
  },
  created() {
    //this.loadData();
  },
  mounted() {
   
  }, components: {
   SideBarAdmin
  }
};
</script>
<style scoped>

div.content {
  margin-left: 200px;
  padding: 25px;
  height: auto;
  margin-top: 0;
}

@media screen and (max-width: 700px) {
  .sidebar {
    width: 100%;
    height: auto;
    position: relative;
  }
  .sidebar a {
    float: left;
  }
  div.content {
    margin-left: 0;
  }
}

.footer {
  margin-left: 200px;
}
</style>
